module.exports = __webpack_public_path__ + "static/media/d5fe3293-f078-45af-b587-1617247e99dc_1.415c560ce3423b1ce60dc3d19c4004e2.17e758c5.jpeg";